import { render, staticRenderFns } from "./RoHSectionHeadline.vue?vue&type=template&id=5d17a9c7&scoped=true&"
import script from "./RoHSectionHeadline.vue?vue&type=script&lang=js&"
export * from "./RoHSectionHeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d17a9c7",
  null
  
)

export default component.exports